var generateStyle = function generateStyle(componentTheme) {
  return {
    container: {
      position: 'relative',
      padding: componentTheme.containerPadding
    },
    alert: {
      display: 'block'
    }
  };
};
export default generateStyle;